<div class="app-select-root m-0 relative w-full overflow-visible">
  <label *ngIf="label" [ngClass]="labelClass">
    {{ label }}
    <span *ngIf="required" class="text-red600">*</span>
  </label>
 
  <button
    #triggerButton
    type="button"
    [disabled]="isDisabled"
    [attr.aria-disabled]="isDisabled || isEmptyDisabled"
    (click)="toggle()"
    class="flex w-full cursor-pointer items-center justify-between rounded-lg border border-slate300 px-3 text-left text-sm text-slate900 outline-none transition focus:border-indigo700"
    [ngClass]="triggerClassMap"
  >
    <span class="flex min-w-0 items-center gap-2">
      <img
        *ngIf="selectedOption?.imageUrl as imgUrl"
        [src]="imgUrl"
        [alt]="selectedLabel + ' logo'"
        class="h-6 w-6 shrink-0 rounded object-contain"
      />
      <span class="truncate" [ngClass]="[triggerTextSizeClass, selectedLabel ? 'text-slate900' : 'text-slate400']">
        {{ selectedLabel || placeholder }}
      </span>
    </span>
    <span class="ml-3 flex items-center gap-2 text-slate600">
      <button *ngIf="clearable && selectedLabel" type="button" (click)="clearValue($event)" class="text-slate400 hover:text-slate600 outline-none rounded-sm">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <span aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.235 6.49L7.53 9.59a.7.7 0 00.94 0l3.295-3.1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </span>
  </button>
 
  <div
    #dropdownMenu
    *ngIf="isOpen"
    [ngStyle]="dropdownStyle"
    class="flex flex-col overflow-hidden rounded-lg border border-slate200 bg-white shadow-xl"
  >
    <div *ngIf="searchable" class="border-b border-slate200 px-2 py-1.5">
      <input
        type="text"
        [value]="searchQuery"
        (input)="searchQuery = $any($event.target).value"
        placeholder="Search..."
        class="w-full rounded-md border border-slate200 px-2 py-1.5 text-sm text-slate900 outline-none focus:border-indigo500"
        (click)="$event.stopPropagation()"
      />
    </div>
    <ul *ngIf="hasOptions || optionGroups.length" class="max-h-56 overflow-y-auto py-1">
      <ng-container *ngIf="optionGroups.length; else flatOptions">
        <ng-container *ngFor="let group of optionGroups">
          <li class="px-3 py-1.5 text-xs font-medium uppercase tracking-wider text-indigo500">
            {{ group.heading }}
          </li>
          <ng-container *ngFor="let option of group.options">
            <button
              type="button"
              (click)="selectOption(option)"
              class="flex w-full cursor-pointer items-center gap-3 px-3 py-2 text-left text-sm transition hover:bg-indigo50"
              [ngClass]="isOptionSelected(option) ? 'bg-indigo50 text-indigo700' : 'text-slate700'"
            >
              <img
                *ngIf="option.imageUrl"
                [src]="option.imageUrl"
                [alt]="option.label + ' logo'"
                class="h-7 w-7 shrink-0 rounded object-contain"
              />
              <div class="flex-1 min-w-0">
                <div class="truncate font-medium text-slate900">
                  {{ option.label }}
                </div>
                <div *ngIf="option.subtext" class="text-xs text-slate500 mt-0.5 truncate">
                  {{ option.subtext }}
                </div>
              </div>
              <span *ngIf="isOptionSelected(option)" class="ml-auto shrink-0 text-indigo600">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.4717 4.86142C12.7314 5.10794 12.7421 5.51887 12.4956 5.77854L7.1623 11.3976C7.04083 11.5256 6.87255 11.598 6.69614 11.598C6.51974 11.598 6.35145 11.5256 6.22999 11.3976L3.56332 8.58805C3.3168 8.32838 3.32746 7.91745 3.58713 7.67093C3.8468 7.42441 4.25773 7.43507 4.50425 7.69474L6.69614 10.0034L11.5545 4.88535C11.801 4.62568 12.2119 4.61501 12.4717 4.86142Z" fill="currentColor"/>
                </svg>
              </span>
            </button>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-template #flatOptions>
        <ng-container *ngFor="let option of filteredOptions">
          <button
            type="button"
            (click)="selectOption(option)"
            class="flex w-full items-center gap-3 px-3 py-2 text-left text-sm transition hover:bg-indigo50"
            [ngClass]="isOptionSelected(option) ? 'bg-indigo50 text-indigo700' : 'text-slate700'"
          >
            <img
              *ngIf="option.imageUrl"
              [src]="option.imageUrl"
              [alt]="option.label + ' logo'"
              class="h-7 w-7 shrink-0 rounded object-contain"
            />
            <div class="flex-1 min-w-0">
              <div class="truncate font-medium text-slate900">
                {{ option.label }}
              </div>
              <div *ngIf="option.subtext" class="text-xs text-slate500 mt-0.5 truncate">
                {{ option.subtext }}
              </div>
            </div>
            <span *ngIf="isOptionSelected(option)" class="ml-auto shrink-0 text-indigo600">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.4717 4.86142C12.7314 5.10794 12.7421 5.51887 12.4956 5.77854L7.1623 11.3976C7.04083 11.5256 6.87255 11.598 6.69614 11.598C6.51974 11.598 6.35145 11.5256 6.22999 11.3976L3.56332 8.58805C3.3168 8.32838 3.32746 7.91745 3.58713 7.67093C3.8468 7.42441 4.25773 7.43507 4.50425 7.69474L6.69614 10.0034L11.5545 4.88535C11.801 4.62568 12.2119 4.61501 12.4717 4.86142Z" fill="currentColor"/>
              </svg>
            </span>
          </button>
        </ng-container>
      </ng-template>
    </ul>
 
    <div *ngIf="!hasOptions && !optionGroups.length" class="px-3 py-3 text-sm text-slate500" role="status">
      {{ resolvedEmptyMessage }}
    </div>
  </div>
 
  <p class="mt-1 text-xs text-red600">
    {{ shouldShowError ? (error || fallbackError) : '' }}
  </p>
</div>
